import i18next from 'i18next';

i18next.addResources('es_CL', 'Error', {
  defaultImgAlt: 'Imagen de error',
  defaultErrorTitle: 'Se ha producido un error',
  defaultErrorImage: 'Por favor vuelve a intentarlo más tarde'
});
